<template>
  <div v-loading="loaderOsebniPodatki">
    <div class="odmik-v-kartici">
      <div>
        <div class="icon-left">
          <p class="open-sans-20pt">
            Pozdravljeni, {{ this.osebniPodatki.name }}
          </p>
        </div>
      </div>
      <div>
        <div>
          <p class="postavitev-avatarja" v-loading="avatarLoading">
            <img :src="avatarURL" class="stil-slike" v-if="avatarURL !== null">
          </p>
          <div class="navadno-besedilo postavitev-osebnih-podatkov">
            <div>
              <b>
                {{ this.osebniPodatki.name }}
              </b>
            </div>
            <div>
              <b>
                {{ this.osebniPodatki.email }}
              </b>
            </div>
            <div>
              {{ this.celotenNaslov }}
            </div>
            <div>
              Telefonska številka:
              <b>
                {{ this.osebniPodatki.phone }}
              </b>
            </div>
            <div class="odmik-gumba-urejanje-profila-desktop">
              <div>
                <a href="/Mojprofil/Osnovno">
                  <el-button class="belo-ozadje-gumba">
                      <span>
                        <img src="/static/img/Domov/icon-awesome-user-alt.png"/>
                      </span>
                    <span>
                        <span class="urejanje-profila-gumb">
                          UREJANJE T-2 ID
                        </span>
                      </span>
                  </el-button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { PridobiStranko } from '../../../../../assets/js/globalne_funkcije/PridobivanjeStranke/PridobiStranko'
import { Button } from 'element-ui'
import ClientAgent from '../../../../../assets/js/clientAgent'

export default {
  name: 'KarticaOsebniPodatki',
  mixins: [
    PridobiStranko
  ],
  components: {
    [Button.name]: Button
  },
  data () {
    return {
      clientAgent: null,
      osebniPodatki: [],
      loaderOsebniPodatki: true,
      avatarURL: null,
      avatarLoading: true,
      celotenNaslov: ''
    }
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.GetUserData()
    this.avatarURL = this.PridobiAvatar()
    this.avatarLoading = this.avatarURL === false
    this.$root.$on('posodobitevSlikeHandler', () => {
      this.avatarURL = this.PridobiAvatar()
      this.avatarLoading = false
    })
  },
  methods: {
    PrenosniPodatkiStranka (osebniPodatki) {
      this.celotenNaslov = ''
      this.osebniPodatki = osebniPodatki
      if (osebniPodatki.address !== undefined && osebniPodatki.address !== '') {
        let naslovArray = this.osebniPodatki.address.split(',')
        this.celotenNaslov = naslovArray[0] + ' ' + osebniPodatki.hisnaStevilka
        naslovArray.slice(1).forEach(podatek => {
          this.celotenNaslov += ',' + podatek
        })
      }
      this.loaderOsebniPodatki = false
    }
  }
}
</script>

<style scoped src="../../../../../../static/css/Domov/naslovna-stran.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Domov/Komponente/KarticaOsebniPodatki.vue